/* eslint-disable camelcase */
import {
  F360Product,
  IFranqueadores,
  IUserProfile,
  LocalStorageKeys
} from "@/core/@types/types";
import { event } from "vue-gtag";
import { IStorage } from "../storage/Storage";
import { computed } from "vue";
import { AnalyticsEvents } from "./types";
import { Router } from "vue-router";
import useStorage from "../useStorage";

interface ICustomDimension {
  page_location: string;
  page_name: string;
  page_path: string;
  user_email: string;
  user_grupo: string;
  produto_financas: string;
  //informações que precisariam ser atualizadas de acordo com o finanças
  grupo_codigo: string;
  grupo_franqueadores: string;
  grupo_id: string;
  grupo_marcas: string | string[];
  grupo_nome: string;
  grupo_qtd_empresas: number;
  grupo_tipo_perfil: string | number;
  usuario_adm: string | boolean;
  usuario_email: string;
  usuario_id: string;
  usuario_nome: string;
  usuario_pagina_inicial: string;
}

type TAnalyticsEventProps = Record<string, string | number | boolean | null>;

export default function useAnalytics(
  storage: IStorage = useStorage(),
  route?: Router
) {
  const userData = () =>
    storage.get<IUserProfile>(LocalStorageKeys.UserProfile);

  const findFranqueador = (franqueadores: IFranqueadores[]): string => {
    if (!franqueadores) return "";

    const nomes = franqueadores.map(
      (franqueador) => franqueador?.Franqueador?.Value?.Nome
    );

    return nomes.join("; ");
  };

  const getCustomDimension = computed(() => {
    const user = userData();

    const customDimensions: ICustomDimension = {
      user_email: user?.Email || "",
      user_grupo: user?.Grupo || "",
      page_location: window.location.href,
      page_path: route?.currentRoute.value.path || "",
      page_name: route?.currentRoute.value.name?.toString() || "",
      produto_financas:
        route?.currentRoute.value.meta.module || F360Product.Financas,
      //informações que precisariam ser atualizadas de acordo com o finanças
      grupo_codigo: user?.CodigoCliente || "",
      grupo_franqueadores:
        findFranqueador(
          (user?.Franqueadores as unknown as IFranqueadores[]) || []
        ) || "",
      grupo_id: user?._id || "",
      grupo_marcas: user?.Marcas?.join("; ") || "",
      grupo_nome: user?.Nome || "",
      grupo_qtd_empresas: user?.QtdEmpresa || 0,
      grupo_tipo_perfil: user?.Perfil || "",
      usuario_adm: user?.PerfilAdm || "",
      usuario_email: user?.Email || "",
      usuario_id: user?._id || "",
      usuario_nome: user?.Nome || "",
      usuario_pagina_inicial: user?.PaginaInicial || ""
    };

    return customDimensions;
  });

  const sendCustomDimensions = () =>
    event("custom_dimensions", getCustomDimension.value);

  const sendEvent = (
    categoria: string,
    evento: string,
    props: TAnalyticsEventProps = {}
  ) =>
    event(evento, {
      event_category: categoria,
      ...getCustomDimension.value,
      ...props
      //debug_mode: true,
    });

  const sendTempoEmTela = (pageName: string) =>
    event(AnalyticsEvents.TEMPO, {
      ...getCustomDimension.value,
      page_name: pageName,
      page_start_time: new Date().getTime()
    });

  return {
    getCustomDimension,
    sendTempoEmTela,
    sendCustomDimensions,
    sendEvent
  };
}
